import { isChannelRequestError } from 'shared/channels/errors';
import { isNoProjectAccessFailure, ProjectDataDownloadFailure } from './projectDataModel';

/**
 * The worker could not download the project's data for a reason the page shows.
 * `failure` is an own field, so it crosses the channel in the error's `cause`.
 */
export class ProjectDataDownloadError extends Error {
  readonly failure: ProjectDataDownloadFailure;

  constructor(message: string, failure: ProjectDataDownloadFailure) {
    super(message);
    this.name = 'ProjectDataDownloadError';
    this.failure = failure;
  }
}

function readFailure(error: unknown): unknown {
  // In the worker the error itself; on the page the worker's error as the channel serialized it.
  const source = isChannelRequestError(error) ? error.cause : error;
  return typeof source === 'object' && source !== null && 'failure' in source ? source.failure : undefined;
}

/** The download failed because the user has no access to the project, wherever the error is read. */
export function isNoProjectAccessDownloadFailure(error: unknown): boolean {
  return isNoProjectAccessFailure(readFailure(error));
}
